import {create} from 'zustand';

type HalfviewStore = {
  open: boolean;
  classnames: string;
  isFullView: boolean;
  openHalfview: () => void;
  closeHalfview: () => void;
  setClassnames: (classnames: string) => void;
  setIsFullView: (isFullView: boolean) => void;
};

export const useHalfviewStore = create<HalfviewStore>()((set) => ({
  open: false,
  classnames: '',
  isFullView: false,
  openHalfview: () => {
    set((prev) => ({...prev, open: true}));
  },
  closeHalfview: () => {
    set((prev) => ({...prev, open: false}));
  },
  setClassnames: (classnames: string) => {
    set((prev) => ({...prev, classnames}));
  },
  setIsFullView: (isFullView: boolean) => {
    set((prev) => ({...prev, isFullView}));
  }
}));
